<template>
    <Page>
        <Container>
            <div class="mx-auto max-w-md">
                <Title>Planner</Title>
            </div>
        </Container>
    </Page>
</template>

<script>
import {defineComponent} from 'vue'

export default defineComponent({
  name: 'Planner'
})
</script>

<style scoped lang="scss">

</style>
